import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash/debounce';

import { contextType } from 'types';
import Button from 'components/Button';
import ContextsMenuOptions from './components/ContextsMenuOptions';

import './style.scss';

export class ContextsMenu extends Component {
  static propTypes = {
    contexts: PropTypes.arrayOf(contextType).isRequired,
    currentContext: contextType.isRequired,
    hasSelectedContext: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    getContexts: PropTypes.func.isRequired,
    selectContext: PropTypes.func.isRequired,
    deselectContext: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.getContexts = _debounce(this.props.getContexts, 200);
  }

  state = {
    isHovered: false,
    isOpen: false,
    searchTerm: '',
  };

  handleMouseEnter = () => {
    this.setState({
      isHovered: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      isHovered: false,
    });
  };

  handleOpen = e => {
    e.preventDefault();
    this.props.getContexts('');
    this.setState({
      isOpen: true,
    });
  };

  handleSelectItem = context => {
    this.props.selectContext(context);
    this.handleClose();
  };

  handleChangeValue = value => {
    this.setState(
      {
        searchTerm: value,
      },
      () => {
        this.getContexts(value);
      },
    );
  };

  handleClickOutside = () => {
    if (this.state.isOpen) {
      this.handleClose();
    }
  };

  handleClose = () => {
    this.setState({
      searchTerm: '',
      isOpen: false,
      isHovered: false,
    });
  };

  deselectContext = e => {
    e.stopPropagation();
    this.props.deselectContext();
  };

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  renderTrigger() {
    const { currentContext, hasSelectedContext } = this.props;

    if (hasSelectedContext) {
      return this.state.isHovered ? (
        <span
          styleName="context"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <span styleName="name">{currentContext.name}</span>
          <span className="icon-close" onClick={this.deselectContext} />
        </span>
      ) : (
        <span
          styleName="context"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <span styleName="name">{currentContext.name}</span>
          <span
            styleName="triangle-icon"
            className="icon-triangle-arrow-down"
          />
        </span>
      );
    }

    return (
      <span styleName="context">
        Select a context
        <span styleName="triangle-icon" className="icon-triangle-arrow-down" />
      </span>
    );
  }

  render() {
    const { searchTerm, isOpen } = this.state;
    const { contexts, currentContext, isLoading } = this.props;
    return (
      <div styleName="contexts-menu">
        {isOpen ? (
          <ContextsMenuOptions
            items={contexts}
            value={searchTerm}
            isLoading={isLoading}
            currentContext={currentContext}
            selectItem={this.handleSelectItem}
            changeValue={this.handleChangeValue}
            closePanel={this.handleClose}
          />
        ) : (
          <Button isText onClick={this.handleOpen} styleName="trigger">
            {this.renderTrigger()}
          </Button>
        )}
      </div>
    );
  }
}

export default ContextsMenu;
